import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Page from '../Page/Page';
import utils, { currency, placeholderRows } from '../../utils';
import InfoTile from '../InfoTile/InfoTile';
import OstolaskuStatusIcon from '../Ostolaskut/OstolaskuStatusIcon';
import Placeholder from '../Placeholder/Placeholder';
import RefreshButton from '../RefreshButton/RefreshButton';

const LASKUVAIHEET = {
  'KESKEN': 'Kesken',
  'HYVAKSYTTY': 'Kesken',
  'AVOIN': 'Tulostettu',
  'OSASUORITUS': 'Osasuoritettu',
  'YLISUORITETTU': 'Ylisuoritettu',
  'VALMIS': 'Maksettu'
};

const laskuvaihe = (key) => {
  return LASKUVAIHEET[key];
};

@inject('laskuStore')
@withRouter
@observer
class Lasku extends Component {
  componentDidMount() {
    this.props.laskuStore.setCurrent(this.props.match.params.id, this.props.location.state);
  }

  render() {
    const { laskuStore } = this.props;
    const kuitti = laskuStore.receipt;

    return (
      <Page
        title={kuitti.MRLASKUNUMERO ? 'Lasku #' + kuitti.MRLASKUNUMERO : 'Lasku'}
        navigationAction={
          <IconButton
            onClick={laskuStore.hideReceipt}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        }
        actions={
          <div>
            <RefreshButton
              loading={laskuStore.isLoading}
              onClick={laskuStore.refresh}
            />
          </div>
        }
      >
        {
          <div className="padding-md">
            <Typography component={'span'} variant="h5" className="text-center">
              <Placeholder size={8}>
                {kuitti.LASKUTUSASIAKASNIMI}
              </Placeholder>
            </Typography>

            <div className="row margin-md-vert padding-sm" style={{ justifyContent: 'center', alignItems: 'center' }}>
              <OstolaskuStatusIcon data={kuitti} />

              <Typography component={'span'} variant="body1" style={{ marginLeft: 8, opacity: .8 }}>
                <Placeholder size={6}>
                  {laskuvaihe(kuitti.laskuvaihe)}
                </Placeholder>
              </Typography>
            </div>

            <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
              <InfoTile title="Laskun päivä" value={utils.ymd2dmy(kuitti.LASKUNPVM)} />
              <InfoTile title="Eräpäivä" value={utils.ymd2dmy(kuitti.ERAPVM)} />
            </div>

            <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
              <InfoTile title="Veroton" value={currency(kuitti.VEROTONSUMMA)} />
              <InfoTile title="ALV" value={currency(kuitti.ALVSUMMA)} />
              <InfoTile title="Summa" value={currency(kuitti.LASKUNSUMMA)} />
            </div>
          </div>
        }

        <div className="padding-md">
          <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
            Laskurivit
          </Typography>

          <table className="full-width inforow-title">
            <thead>
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </thead>

            <tbody>
              {
                kuitti.laskurivit ?
                  kuitti.laskurivit.map((row, idx) =>
                    <tr key={idx}>
                      <td>{row.MAARA} {row.yksikko.TUNNUS}</td>
                      <td>{row.TUOTENIMI}</td>
                      <td className="text-right">{currency(row.VEROTONSUMMA)}</td>
                    </tr>
                  ) :
                  placeholderRows(5).map((_, idx) =>
                    <tr key={idx}>
                      <td>
                        <Placeholder size={4} />
                      </td>
                      <td>
                        <Placeholder size={8} />
                      </td>
                      <td className="text-right">
                        <Placeholder size={4} />
                      </td>
                    </tr>
                  )
              }
            </tbody>
          </table>
        </div>

        {
          ((kuitti.suoritukset && !!kuitti.suoritukset.length) || kuitti.laskuvaihe === 'VALMIS') &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Suoritukset
            </Typography>

            <table className="full-width inforow-title">
              <thead>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {
                  kuitti.suoritukset ?
                    kuitti.suoritukset.map((row, idx) =>
                      <tr key={idx}>
                        <td>{utils.ymd2dmy(row.SUORITUSPVM)}</td>
                        <td className="text-right">{currency(row.SUMMA)}</td>
                      </tr>
                    ) :
                    placeholderRows(2).map((_, idx) =>
                      <tr key={idx}>
                        <td>
                          <Placeholder size={4} />
                        </td>
                        <td className="text-right">
                          <Placeholder size={4} />
                        </td>
                      </tr>
                    )
                }
              </tbody>
            </table>
          </div>
        }
      </Page>
    );
  }
}

export default Lasku;
